import { getNumericParam, setParamIfDefined, setParamIfUndefined, toUrl } from "../utils.js";
export const transform = _ref => {
  let {
    url: originalUrl,
    width,
    height
  } = _ref;
  const url = toUrl(originalUrl);
  setParamIfDefined(url, "w", width, true, true);
  setParamIfDefined(url, "h", height, true, true);
  setParamIfUndefined(url, "crop", "1");
  return url;
};
export const parse = url => {
  const parsed = toUrl(url);
  const width = getNumericParam(parsed, "w");
  const height = getNumericParam(parsed, "h");
  const crop = parsed.searchParams.get("crop") === "1";
  parsed.search = "";
  return {
    base: parsed.toString(),
    width,
    height,
    params: {
      crop
    },
    cdn: "wordpress"
  };
};